// extracted by mini-css-extract-plugin
module.exports = {"promoLink":"hero-link_promoLink__Fd31N"};